// src/components/InvoiceModal.js
// The check-in invoice is the same document as the check-out invoice: one design, one PDF.
// This adapter only maps this screen's field names onto the shared invoice component.
import React, { forwardRef } from "react";
import CheckOutInvoice from "./CheckOutInvoice";

const InvoiceModal = forwardRef(({ isOpen, onClose, guestDetails, hotelDetails }, ref) => {
  const g = guestDetails || {};

  const mapped = {
    hotelId: g.hotelId,
    currency: g.currency || "BWP",
    bookingNo: g.bookingNo,
    name: g.guestName || g.name,
    roomNumber: g.roomNumber ?? g.roomNo,
    checkInDate: g.checkInDate,
    checkOutDate: g.checkOutDate,
    nights: g.daysBooked,
    basePrice: g.basePrice,
    vatPercentage: g.vatPercentage,
    additionalLevies: g.additionalLevies,
    totalAmount: g.totalAmount,
    paymentAmount: g.amountPaid,
    invoiceDate: g.invoiceDate,
    transactionType: g.transactionType,
  };

  return (
    <CheckOutInvoice
      ref={ref}
      isOpen={!!isOpen}
      onClose={onClose}
      hotelDetails={hotelDetails}
      guestDetails={mapped}
      billingRecords={[]}
    />
  );
});

export default InvoiceModal;
